<!-- customer-panel/src/views/Pages/Tables/detail/components/view/CreateViewForm.vue -->
<template>
    <div class="create-view-form">
        <a-form @submit.prevent="handleSubmit">
            <a-form-item :label="$t('tables.viewName')" :required="true">
                <a-input v-model="name" :placeholder="$t('tables.enterViewName')" />
            </a-form-item>
            <a-form-item :label="$t('message.description')">
                <a-input v-model="description" :placeholder="$t('tables.enterDesc')" />
            </a-form-item>
            <div class="form-actions">
                <a-button @click="$emit('cancel')">{{ $t("wp.cancel") }}</a-button>
                <a-button type="primary" htmlType="submit">{{ $t("message.save") }}</a-button>
            </div>
        </a-form>
    </div>
</template>

<script>
import { TABLE_API } from "../../../../../api/table";

export default {
    name: "CreateViewForm",
    props: {
        filters: {
            type: Array,
            default: () => [],
        },
        sort: {
            type: Object,
            default: () => ({}),
        },
        search: {
            type: String,
            default: "",
        },
        hiddenFields: {
            type: Array,
            default: () => [],
        },
        lockedFields: {
            type: Array,
            default: () => [],
        },
        tableId: {
            type: String,
            required: true,
        },
        groupValue: {
            type: Object,
            default: () => ({}),
        },
        colorConditions: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            name: "",
            description: "",
        };
    },
    methods: {
        async handleSubmit() {
            if (!this.name.trim()) {
                this.$message.error(this.$t('tables.viewNameRequired'));
                return;
            }
            try {
                const newView = await TABLE_API.createView(
                    this.tableId,
                    this.name,
                    this.description,
                    this.filters,
                    this.sort,
                    null, // Cursor değeri isterseniz ekleyebilirsiniz.
                    this.search,
                    this.hiddenFields,
                    this.lockedFields,
                    this.groupValue,
                    this.colorConditions
                );
                this.$emit("view-created", newView);
            } catch (error) {
                console.error("Görünüm oluşturulurken hata oluştu:", error);
                this.$message.error(this.$t("tables.errorCreatingView"));
            }
        },
    },
};
</script>

<style scoped lang="scss">
.create-view-form {
    .form-actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
    }
}
</style>
